import React from 'react';
import {
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
} from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import EventIcon from '@mui/icons-material/Event';
import { useNavigate, useParams } from 'react-router-dom';

import { TextModuleCategoryOverview } from './TextModuleCategory/TextModuleCategoryOverview';
import { TextModuleOverview } from './TextModuleOverview';
import { TextModuleMeetingOverview } from './TextModuleAppointment/TextModuleMeetingOverview';

enum TEXTMODULE_VIEW {
  CATEGORIES = 'categories',
  MODULES = 'modules',
  MEETINGS = 'meetings',
}

export const TextModulSectionMain: React.FC = () => {
  const { currentView } = useParams();
  const navigate = useNavigate();

  const view = (currentView as TEXTMODULE_VIEW) ?? TEXTMODULE_VIEW.CATEGORIES;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <List>
            <ListItemButton
              selected={view === TEXTMODULE_VIEW.CATEGORIES}
              onClick={() =>
                navigate(`/textmodules/view/${TEXTMODULE_VIEW.CATEGORIES}`)
              }
            >
              <ListItemIcon>
                <CategoryIcon />
              </ListItemIcon>
              <ListItemText primary='Kategorien' />
            </ListItemButton>

            <ListItemButton
              selected={view === TEXTMODULE_VIEW.MODULES}
              onClick={() =>
                navigate(`/textmodules/view/${TEXTMODULE_VIEW.MODULES}`)
              }
            >
              <ListItemIcon>
                <TextSnippetIcon />
              </ListItemIcon>
              <ListItemText primary='Textbausteine' />
            </ListItemButton>

            <ListItemButton
              selected={view === TEXTMODULE_VIEW.MEETINGS}
              onClick={() =>
                navigate(`/textmodules/view/${TEXTMODULE_VIEW.MEETINGS}`)
              }
            >
              <ListItemIcon>
                <EventIcon />
              </ListItemIcon>
              <ListItemText primary='Termin E-Mails' />
            </ListItemButton>
          </List>
        </Grid>

        <Grid item xs={10}>
          <Collapse in={view === TEXTMODULE_VIEW.CATEGORIES}>
            <TextModuleCategoryOverview />
          </Collapse>

          <Collapse in={view === TEXTMODULE_VIEW.MODULES}>
            <TextModuleOverview />
          </Collapse>

          <Collapse in={view === TEXTMODULE_VIEW.MEETINGS}>
            <TextModuleMeetingOverview />
          </Collapse>
        </Grid>
      </Grid>
    </>
  );
};
